module.exports = __webpack_public_path__ + "img/03.a42194e5.png";